import { Accent } from "@/components/kit/Accent";
import { cn } from "@/lib/utils";

/** The deep-teal band that opens a page: title, one line of context, and whatever the page tracks. */
export const PlanHero = ({ eyebrow, title, lead, aside, footer, className }) => (
  <section
    className={cn(
      "relative overflow-hidden rounded-[24px] px-6 py-7 text-brand-mint shadow-[0_20px_44px_-20px_rgba(15,46,44,0.55)] sm:px-9 sm:py-9",
      className
    )}
    style={{ backgroundColor: "#0F2E2C" }}
  >
    <span
      aria-hidden
      className="pointer-events-none absolute -top-28 -right-16 h-72 w-72 rounded-full"
      style={{ background: "radial-gradient(circle, rgba(230,239,234,0.10), transparent 70%)" }}
    />
    <div className="relative flex min-w-0 flex-col-reverse gap-6 sm:flex-row sm:items-center sm:gap-8">
      <div className="min-w-0 flex-1">
        {eyebrow && (
          <p className="text-[11.5px] font-bold uppercase tracking-[0.09em] text-brand-mint/75">{eyebrow}</p>
        )}
        <h1 className="mt-2 font-display text-[26px] font-bold leading-[1.1] text-white sm:text-[32px]">
          <Accent>{title}</Accent>
        </h1>
        {lead && <p className="mt-3 max-w-prose text-[13.5px] leading-[1.6] text-white/70">{lead}</p>}
      </div>
      {aside}
    </div>
    {footer && <div className="relative mt-6">{footer}</div>}
  </section>
);

/** The plan-progress bar used inside a hero. */
export const HeroProgress = ({ label = "Full plan progress", done = 0, total = 0, percent = 0, testId }) => (
  <>
    <div className="mb-2 flex justify-between text-[12px] font-semibold text-white/70">
      <span>{label}</span>
      <span data-testid={testId}>
        <b className="font-bold text-white">{done}</b> of {total} days
      </span>
    </div>
    <div className="h-1.5 w-full overflow-hidden rounded-full bg-white/15">
      <div
        className="h-full rounded-full transition-[width] duration-500"
        style={{ width: `${percent}%`, backgroundColor: "#DD4115" }}
      />
    </div>
  </>
);
